import React, { useState, useEffect } from 'react';
import { ArrowUp, ChevronDown, Menu, X } from 'lucide-react';

export default function SubMenuAnclaGrado() {
  const [isVisible, setIsVisible] = useState(false);
  const [activeSection, setActiveSection] = useState('');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const menuItems = [
    { label: 'Perfil profesional', href: '#profesional' },
    { label: 'Campo ocupacional', href: '#campo' },
    { label: 'Malla curricular', href: '#malla' },
     { label: 'Beneficios', href: '#estudiar' },
    { label: 'Docentes', href: '#docentes' },
    { label: 'Proceso de matrícula', href: '#proceso' },
  ];

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 400) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
        setIsMobileMenuOpen(false); // Cierra el menú móvil si vuelve arriba
      }

      const sections = ['ingreso', 'egreso', 'malla', 'docentes', 'requisitos'];
      for (const section of sections) {
        const el = document.getElementById(section);
        if (el) {
          const rect = el.getBoundingClientRect();
          if (rect.top <= 140 && rect.bottom >= 140) {
            setActiveSection(`#${section}`);
            break;
          }
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  // Obtiene el texto de la sección activa para mostrarlo en el botón móvil
  const currentLabel = menuItems.find(item => item.href === activeSection)?.label || 'Ir a';

  return (
    <>
      {/* MENÚ SUPERIOR FIXED */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 bg-white border-b border-[#f1f5f9] shadow-sm transition-all duration-300 transform ${
          isVisible ? 'translate-y-0 opacity-100' : '-translate-y-full opacity-0 pointer-events-none'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          
          {/* VISTA MÓVIL (Sin overflow: Un botón colapsable limpio) */}
          <div className="md:hidden flex flex-col w-full">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="flex items-center justify-between w-full py-4 text-sm font-bold uppercase tracking-wider text-[#004270] focus:outline-none"
            >
              <div className="flex items-center gap-2">
                               <span>{currentLabel}</span>
              </div>
              <ChevronDown className={`h-5 w-5 text-[#64748b] transition-transform duration-200 ${isMobileMenuOpen ? 'rotate-180' : ''}`} />
            </button>

            {/* Listado desplegable vertical en móvil */}
            {isMobileMenuOpen && (
              <div className="absolute left-0 right-0 top-full bg-white border-b border-[#f1f5f9] shadow-lg flex flex-col py-2 animate-fadeIn">
                {menuItems.map((item, index) => {
                  const isActive = activeSection === item.href;
                  return (
                    <a
                      key={index}
                      href={item.href}
                      onClick={() => {
                        setActiveSection(item.href);
                        setIsMobileMenuOpen(false);
                      }}
                      className={`px-6 py-3 text-sm font-bold uppercase tracking-wider transition-colors ${
                        isActive 
                          ? 'bg-[#f1f5f9] text-[#004270] border-l-4 border-[#febe10]' 
                          : 'text-[#64748b] hover:text-[#004270]'
                      }`}
                    >
                      {item.label}
                    </a>
                  );
                })}
              </div>
            )}
          </div>

          {/* VISTA ESCRITORIO (El menú tradicional de antes, oculto en móviles) */}
          <div className="hidden md:flex items-center justify-center gap-8">
            {menuItems.map((item, index) => {
              const isActive = activeSection === item.href;
              return (
                <a
                  key={index}
                  href={item.href}
                  onClick={() => setActiveSection(item.href)}
                  className={`relative whitespace-nowrap py-4 text-sm font-bold transition-all duration-200 uppercase tracking-wider border-b-2 ${
                    isActive
                      ? 'text-[#004270] border-[#febe10]'
                      : 'text-[#64748b] border-transparent hover:text-[#004270] hover:border-[#febe10]'
                  }`}
                >
                  {item.label}
                </a>
              );
            })}
          </div>

        </div>
      </nav>

      {/* BOTÓN VOLVER HACIA ARRIBA (CENTRADO ABAJO) */}
      <div 
        className={`fixed bottom-4 left-1/2 -translate-x-1/2 z-50 transition-all duration-300 ${
          isVisible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-4 scale-75 pointer-events-none'
        }`}
      >
        <button
          onClick={scrollToTop}
          aria-label="Volver al inicio"
          className="flex h-12 w-12 items-center justify-center rounded-full bg-[#004270] text-white shadow-xl transition-all duration-200 hover:bg-[#febe10] hover:text-[#004270] hover:scale-110 focus:outline-none focus:ring-2 focus:ring-[#febe10]"
        >
          <ArrowUp className="h-5 w-5" strokeWidth={2.5} />
        </button>
      </div>
    </>
  );
}